var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.kycStatus && _vm.kycStatus !== 'Not_checked')?_c('ds-tag',{attrs:{"label":_vm.kycStatus,"version":_vm.kycTagVersion,"icon":_vm.kycIcon,"icon-size":"1rem"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }